import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme } from '@mui/material/styles';
import * as Typography from '../styles/typography/typography';
export var ROOT_PREFIX = 'EmbersTypography';
export var createTypographyTheme = function createTypographyTheme(componentType) {
  var extraProps = componentType ? {
    defaultProps: {
      component: componentType
    }
  } : {};
  return createTheme({
    components: {
      // @ts-ignore
      MuiTypography: _objectSpread(_objectSpread({}, extraProps), {}, {
        styleOverrides: {
          h1: Typography.PROMETHEAN_TYPOGRAPHY_H1,
          h2: Typography.PROMETHEAN_TYPOGRAPHY_H2,
          h3: Typography.PROMETHEAN_TYPOGRAPHY_H3,
          h4: Typography.PROMETHEAN_TYPOGRAPHY_H4,
          h5: Typography.PROMETHEAN_TYPOGRAPHY_H5,
          subtitle1: Typography.PROMETHEAN_TYPOGRAPHY_SUBTITLE_01,
          subtitle2: Typography.PROMETHEAN_TYPOGRAPHY_SUBTITLE_02,
          root: _defineProperty({}, "&.".concat(ROOT_PREFIX), {
            '&-subtitle3': Typography.PROMETHEAN_TYPOGRAPHY_SUBTITLE_03,
            '&-subtitle4': Typography.PROMETHEAN_TYPOGRAPHY_SUBTITLE_04,
            '&-body': Typography.PROMETHEAN_TYPOGRAPHY_BODY,
            '&-bodyLink': Typography.PROMETHEAN_TYPOGRAPHY_BODY_LINK,
            '&-button1': Typography.PROMETHEAN_TYPOGRAPHY_BUTTON,
            '&-button1Uppercase': Typography.PROMETHEAN_TYPOGRAPHY_BUTTON_SMALL,
            '&-button3': Typography.PROMETHEAN_TYPOGRAPHY_BUTTON_UPPERCASE,
            '&-button2Uppercase': Typography.PROMETHEAN_TYPOGRAPHY_BUTTON_SMALL_UPPERCASE,
            '&-small': Typography.PROMETHEAN_TYPOGRAPHY_SMALL_TEXT,
            '&-smallUppercase': Typography.PROMETHEAN_TYPOGRAPHY_SMALL_TEXT_UPPERCASE,
            '&-eyebrow': Typography.PROMETHEAN_TYPOGRAPHY_EYEBROW,
            '&-eyebrowUppercase': Typography.PROMETHEAN_TYPOGRAPHY_EYEBROW_UPPERCASE
          })
        }
      })
    }
  });
};